export default __webpack_public_path__ + "static/media/business-2.ec04e211.jpg";